// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AFAO","right":"styles_right__1S1mg"};